export const calculateFees = (type, fee, regularPrice) => {
    // Vérifier si l'un des paramètres est manquant ou invalide
    if (!type || fee === undefined || regularPrice === undefined) {
      return 0;  // Retourne 0 si l'un des paramètres est absent
    }
  
    let feeAmount = 0;
  
    if (type === "amount") {
      feeAmount = fee;
    } else if (type === "percent") {
      feeAmount = (regularPrice * (fee / 100));
    }
  
    return feeAmount;
  }

 export const  findClosestProduct = (currentAmount, tableOfProducts) => {
    // Convert prices and sort products by price (ascending)
    const sortedProducts = tableOfProducts
      .map(p => ({ ...p, priceNumber: parseFloat(p.regular_price) }))
      .filter(p => !isNaN(p.priceNumber))
      .sort((a, b) => a.priceNumber - b.priceNumber);
  
    for (let product of sortedProducts) {
      const diff = Math.abs(product.priceNumber - currentAmount);
      
      if (diff <= 5) {
        return product;
      }
  
      if (product.priceNumber > currentAmount) {
        return product;
      }
    }
  
    // If no match, return null or the last product
    return sortedProducts.length ? sortedProducts[sortedProducts.length - 1] : null;
  }
  
  